import { TypographyStyleOptions } from '@material-ui/core/styles/createTypography'

interface FontStyle {
    [key: string]: TypographyStyleOptions
}

const fontStyles: FontStyle = {
    Title: {
        fontFamily: 'Asap Bold',
        fontWeight: 700,
        fontStyle: 'normal',
        fontSize: '3rem',
        lineHeight: 1.2,
    },
    Title2: {
        fontFamily: 'Asap Bold',
        fontWeight: 700,
        fontStyle: 'normal',
        fontSize: '2rem',
        lineHeight: 1.2,
    },
    Title3: {
        fontFamily: 'Asap Bold',
        fontWeight: 700,
        fontStyle: 'normal',
        fontSize: '1.5rem',
        lineHeight: 1.2,
    },
    Subtitle: {
        fontFamily: 'Asap Regular',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: '1.25rem',
        lineHeight: 1.2,
    },
    NormalText: {
        fontFamily: 'Asap Regular',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: '1rem',
        lineHeight: 1.5,
    },
    SmallText: {
        fontFamily: 'Asap Regular',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: '0.75rem',
        lineHeight: 0.85,
    },
    ButtonText: {
        fontFamily: 'Asap Bold',
        fontWeight: 700,
        fontStyle: 'normal',
        fontSize: '1rem',
        lineHeight: 1.2,
    },
}

export default fontStyles
